import React from 'react';

import PageSection from '../../components/PageSection';
import { useAPI } from '../../api';

const AllowSignup = () => {
	let api = useAPI();

	const [allowSignup, setAllowSignup] = React.useState<boolean | null>(null);
	const [saved, setSaved] = React.useState(false);

	React.useEffect(() => {
		api.get<{ allowSignup: boolean }>('/api/system/settings/signup')
		.then(json => setAllowSignup(json.allowSignup));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const save = (value: boolean) => {
		setSaved(false);
		api.post<{ allowSignup: boolean }>('/api/system/settings/signup', { allowSignup: value })
		.then(json => {
			setAllowSignup(json.allowSignup);
			setSaved(true);
		});
	};

	if (allowSignup === null) return null;

	return (
		<div>
			<PageSection level={3} title="User Sign-Up">
				<p>
					Allow new users to sign up for an account on their own. When enabled, a "Sign Up" option will appear
					on the login page, letting anyone with a valid email address create an account. When disabled, accounts
					can only be created by an administrator or via an invite.
				</p>

				<p>
					<label>
						<input
							type="checkbox"
							checked={allowSignup}
							onChange={e => save(e.target.checked)}
						/>
						{' '}Allow user self-sign-up
					</label>
				</p>

				{saved && <p>Saved.</p>}
			</PageSection>
		</div>
	);
};

export default AllowSignup;
